import { gqlType } from "@hifieng/common";

export const getStatusText = (status: string) => {
  let statusText = "Travelling";

  switch (status) {
    case gqlType.PigStatus.ApproachingPoi:
      statusText = "Approaching POI";
      break;
    case gqlType.PigStatus.Detected:
      statusText = "Detected";
      break;
    case gqlType.PigStatus.Moving:
      statusText = "Moving";
      break;
    case gqlType.PigStatus.NotDetected:
      statusText = "No Movement Detected";
      break;
    case gqlType.PigStatus.Stopped:
      statusText = "Stopped";
      break;
    case gqlType.PigStatus.Completed:
      statusText = "Completed";
      break;
    case gqlType.TrainStatus.ApproachingStation:
      statusText = "Approaching Station";
      break;
  }
  return statusText;
};
